import React from "react";
import { NavigationLinks, Section, Text } from "../../../components";
import { BannerPages, DownloadCondicoesGerais } from "../Sections";
import ImageNavigationLinks from "../../../assets/images/residencial/ilustracao-homem-casa.svg";

const CondicoesGeraisSeguroCompreensivo = () => {
  return (
    <>
      <BannerPages
        subtitle={
          <>
            <Text>Apólice de Seguro Compreensivo de Imóveis </Text>
            <Text>Vigência a partir de Agosto de 2013</Text>
          </>
        }
        bannerTitle="Condições gerais"
      />
      <Section
        as={DownloadCondicoesGerais}
        sectionName="Download de condições gerais seguro fácil residencial"
        tipoDeSeguroPage="seguro_imoveis"
      />
      <Section
        as={NavigationLinks}
        sectionName="Ainda podemos te ajudar?"
        sectionTitle="Ainda podemos te ajudar?"
        imgSrc={ImageNavigationLinks}
      />
    </>
  );
};

export default CondicoesGeraisSeguroCompreensivo;
